import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2.0043 0.589966L2.00015 0.585815L0.585938 2.00003L1.58591 3H1V9L7.58591 9L9.58628 11.0004H1V21L19.5859 21L22.0002 23.4142L23.4101 22.0043L2 0.594267L2.0043 0.589966ZM9 17.0001H4L4 15.0001L9 15.0001V17.0001Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 18.7658V11.0004H15.2345L23 18.7658Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.2342 9L23 9V3H7.23416L13.2342 9Z"}}]};

const CreditcardOffFilled = Vue.extend<IconProps>({
  name: 'CreditcardOffFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'creditcard-off-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default CreditcardOffFilled;
